export interface UpcomingEscapeRowEligibilityInput {
  flightDataLoading: boolean
  flightUpsellEnabled: boolean
  hasExistingFlight: boolean
  carHireDataLoading: boolean
  carHireUpsellEnabled: boolean
  hasExistingCarHire: boolean
  insuranceDataLoading: boolean
  insuranceUpsellEnabled: boolean
  insuranceBookingProtectionDataLoading: boolean
  insuranceBookingProtectionUpsellEnabled: boolean
  tourDataLoading: boolean
  tourUpsellEnabled: boolean
  hasExistingTour: boolean
  airportTransferDataLoading: boolean
  airportTransferUpsellEnabled: boolean
  hasExistingTransfer: boolean
  hasLoungeBenefit: boolean
  loungeEligibleForOrder: boolean
  esimEnabled: boolean
  hasEsimBenefit: boolean
  esimBenefitListLoaded: boolean
  esimEligibleForOrder: boolean
  /** Order-level eSIM allowance present (mirrors LoyaltyOrderViewBenefitsEsimItem). */
  hasOrderEsimAllowance: boolean
  /** Trip end date already passed — eSIM row must not render. */
  isPastEsimTrip: boolean
}

export interface UpcomingEscapeRowEligibility {
  showFlight: boolean
  showCarHire: boolean
  showTravelProtection: boolean
  showCancellationProtection: boolean
  showTour: boolean
  showAirportTransfer: boolean
  showLounge: boolean
  showEsim: boolean
}

/**
 * Pure visibility gates for Upcoming Escape commercial / Société rows.
 * Commercial rows stay hidden while their loading flags are true; the booking
 * shell does not wait on these flags.
 */
function getUpcomingEscapeRowEligibility(
  input: UpcomingEscapeRowEligibilityInput,
): UpcomingEscapeRowEligibility {
  return {
    showFlight: !input.flightDataLoading && input.flightUpsellEnabled && !input.hasExistingFlight,
    showCarHire: !input.carHireDataLoading && input.carHireUpsellEnabled && !input.hasExistingCarHire,
    showTravelProtection: !input.insuranceDataLoading && input.insuranceUpsellEnabled,
    showCancellationProtection: !input.insuranceDataLoading
      && !input.insuranceBookingProtectionDataLoading
      && !input.insuranceUpsellEnabled
      && input.insuranceBookingProtectionUpsellEnabled,
    showTour: !input.tourDataLoading && input.tourUpsellEnabled && !input.hasExistingTour,
    showAirportTransfer: !input.airportTransferDataLoading && input.airportTransferUpsellEnabled && !input.hasExistingTransfer,
    showLounge: input.hasLoungeBenefit && input.loungeEligibleForOrder,
    showEsim: input.esimEnabled
      && input.hasEsimBenefit
      && input.esimBenefitListLoaded
      && input.esimEligibleForOrder
      && input.hasOrderEsimAllowance
      && !input.isPastEsimTrip,
  }
}

export function isUpcomingEscapeCommercialLoading(input: Pick<
  UpcomingEscapeRowEligibilityInput,
  | 'flightDataLoading'
  | 'carHireDataLoading'
  | 'insuranceDataLoading'
  | 'insuranceBookingProtectionDataLoading'
  | 'tourDataLoading'
  | 'airportTransferDataLoading'
>): boolean {
  return input.flightDataLoading
    || input.carHireDataLoading
    || input.insuranceDataLoading
    || input.insuranceBookingProtectionDataLoading
    || input.tourDataLoading
    || input.airportTransferDataLoading
}

export default getUpcomingEscapeRowEligibility
